/**
 * Anchor on the checkout Handoff step so the persistent header location
 * indicator can scroll a closed-store diner to the "Select a time" picker
 * (TEAM-13771).
 */
export const CHECKOUT_HANDOFF_ANCHOR_ID = 'checkout-handoff-details';

export const CONFIRM_PICKUP_COPY = {
  heading: 'Confirm your pickup location',
  body: "Please confirm that you'll be picking up your order at the following restaurant.",
  confirm: 'Confirm and place order',
  changeLocation: 'Change location',
  selectTime: 'Select a time',
} as const;
